/**
 * Developer read-outs (fps, draw calls, sim version) are for us, not players.
 * Shown in `pnpm dev`, or anywhere with `?debug` in the address.
 */
export const DEBUG: boolean =
  import.meta.env.DEV || (typeof location !== "undefined" && new URLSearchParams(location.search).has("debug"));
